import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'strLimit'
})
export class StrlimitPipe implements PipeTransform {

  transform(value: string,limit: number): string {
    if(!value) return value;
    else if(value.length<=limit) return value; 
    else return (value.substring(0, limit) + '...') ;
  }

}
